import { Check, Eye, Moon } from "lucide-react";
import { fmtTime, isOvernight } from "@/lib/dates";

export const OvernightTag = () => (
  <span className="ml-1 rounded bg-slate-900 px-1 py-px text-[10px] font-bold text-white" title="Ends next day">+1</span>
);

export const SleepTag = () => (
  <span className="inline-flex items-center gap-1 rounded-full bg-purple-100 px-2 py-0.5 text-[10px] font-semibold text-purple-700">
    <Moon className="h-3 w-3" /> Sleepover
  </span>
);

const CompactChip = ({ shift, type, onClick, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId} title={`${type?.name || "Shift"} ${fmtTime(shift.start)}–${fmtTime(shift.end)}`}
    className={`w-full rounded-md border px-1 py-1 text-left text-[11px] leading-tight transition-shadow hover:shadow-md ${shift.staff_id ? "border-slate-200 bg-white" : "border-amber-300 bg-amber-50"}`}
    style={{ borderLeft: `3px solid ${type?.colour || "#94a3b8"}` }}>
    <div className="font-mono font-semibold text-slate-900">{fmtTime(shift.start)}–{fmtTime(shift.end)}</div>
    <div className="flex items-center gap-1 truncate text-[10px] text-slate-500">
      {isOvernight(shift) && <span className="rounded bg-slate-900 px-0.5 font-bold text-white">+1</span>}
      {type?.is_sleepover && <Moon className="h-3 w-3 text-purple-600" />}
      {shift.needs_ack && (shift.acked_at ? <Check className="h-3 w-3 text-emerald-600" data-testid={`${testId}-seen`} /> : <Eye className="h-3 w-3 text-amber-600" data-testid={`${testId}-not-seen`} />)}
      <span className="truncate">{type?.name || "Shift"}</span>
    </div>
  </button>
);

export const ShiftChip = ({ shift, type, onClick, testId, compact }) => compact ? <CompactChip shift={shift} type={type} onClick={onClick} testId={testId} /> : (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`w-full rounded-lg border px-2 py-1.5 text-left text-xs transition-shadow hover:shadow-md ${shift.staff_id ? "border-slate-200 bg-white" : "border-amber-300 bg-amber-50"}`}
    style={{ borderLeft: `4px solid ${type?.colour || "#94a3b8"}` }}
  >
    <div className="font-mono font-semibold text-slate-900">
      {fmtTime(shift.start)}–{fmtTime(shift.end)}
      {isOvernight(shift) && <OvernightTag />}
    </div>
    <div className="truncate text-slate-500">{type?.name || "Shift"}</div>
    {type?.is_sleepover && <div className="mt-1"><SleepTag /></div>}
    {shift.needs_ack && (
      shift.acked_at
        ? <div className="mt-1 inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-700" data-testid={`${testId}-seen`}><Check className="h-3 w-3" />Seen</div>
        : <div className="mt-1 inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-800" data-testid={`${testId}-not-seen`}><Eye className="h-3 w-3" />Not seen</div>
    )}
  </button>
);
